<template>
  <!-- company-info-view .civ -->
  <div class="civ">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>展会管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">展会管理</div>
        <p style="line-height:40px;color:#808080;font-size:12px;">展会相关的基础数据设置</p>
      </div> 
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" v-model="showTabs">
        <TabPane label="展会信息" name="1">
          <hostExInfo ref="hostExInfo" v-if="String(showTabs) === '1'" />
        </TabPane> 
      </Tabs>
    </div>
  </div>
</template>

<script> 
import hostExInfo from "../host-set/subpages/host-exInfo.vue"; 

export default {
  name: "host-set",
  data () {
    return {
      showTabs: "1",
      show: false,
    };
  },
  components: { 
    hostExInfo, 
  }, 
};
</script>

<style scoped lang="scss">
.civ {
  .header-tool {
    padding: 18px 25px 0 35px;
  }
}
</style>
